/* eslint-disable no-param-reassign */
import { createReducer } from '@reduxjs/toolkit';
import { addPartner, setPartners, resetPartners } from './partners.actions';
import { Partner } from './partners.models';

interface PartnerState {
  partners: {
    [key: Partner['id']]: Partner;
  };
}

const initialState: PartnerState = {
  partners: {},
};

// eslint-disable-next-line import/prefer-default-export
export const reducer = createReducer(initialState, (builder) => {
  builder.addCase(addPartner, (state, action) => {
    state.partners[action.payload.slug] = action.payload;
  });

  builder.addCase(setPartners, (state, action) => {
    const partnerObj = { ...initialState.partners };
    action.payload?.forEach((partner) => {
      partnerObj[partner?.slug] = partner;
    });

    state.partners = partnerObj;
  });

  builder.addCase(resetPartners, (state) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    state = initialState;
  });
});
